import React, { useState, useEffect } from 'react';
import api from '../services/api';
import Modal from '../components/Modal';
import Pagination from '../components/Pagination';

const PAGE_SIZE = 15;

export default function ApprovalRoles() {
  const [roles, setRoles] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: '', description: '', display_order: 0 });
  const [error, setError] = useState('');

  useEffect(() => { loadRoles(); }, [page]);
  async function loadRoles() {
    const { data } = await api.get('/approval-roles', { params: { page, limit: PAGE_SIZE } });
    setRoles(data.data);
    setTotal(data.total);
  }

  async function handleSave() {
    setError('');
    try {
      if (editing) { await api.put(`/approval-roles/${editing.id}`, form); } else { await api.post('/approval-roles', form); }
      setShowModal(false); loadRoles();
    } catch (err) { setError(err.response?.data?.error || 'Erro'); }
  }
  async function handleDelete(id) { if (!window.confirm('Excluir?')) return; try { await api.delete(`/approval-roles/${id}`); loadRoles(); } catch (err) { alert(err.response?.data?.error); } }

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-xl font-bold tracking-tight">Funções de Aprovação</h1>
        <button className="btn btn-primary" onClick={() => { setEditing(null); setForm({ name: '', description: '', display_order: 0 }); setError(''); setShowModal(true); }}>Nova Função</button>
      </div>
      <div className="bg-surface-100 border rounded-md p-4">
        <table className="w-full border-collapse">
          <thead><tr className="border-b">
            <th className="text-left text-2xs font-semibold text-ink-muted uppercase px-3 py-2">Ordem</th>
            <th className="text-left text-2xs font-semibold text-ink-muted uppercase px-3 py-2">Nome</th>
            <th className="text-left text-2xs font-semibold text-ink-muted uppercase px-3 py-2">Descrição</th>
            <th className="text-left text-2xs font-semibold text-ink-muted uppercase px-3 py-2">Ações</th>
          </tr></thead>
          <tbody>
            {roles.map((r) => (
              <tr key={r.id} className="border-b border-subtle hover:bg-surface-inset">
                <td className="px-3 py-3"><span className="doc-code">{r.display_order}</span></td>
                <td className="px-3 py-3 font-medium">{r.name}</td>
                <td className="px-3 py-3 text-sm text-ink-muted">{r.description || '—'}</td>
                <td className="px-3 py-3"><div className="flex gap-1">
                  <button className="btn btn-sm btn-secondary" onClick={() => { setEditing(r); setForm({ name: r.name, description: r.description || '', display_order: r.display_order }); setShowModal(true); }}>Editar</button>
                  <button className="btn btn-sm btn-danger" onClick={() => handleDelete(r.id)}>Excluir</button>
                </div></td>
              </tr>
            ))}
          </tbody>
        </table>
        <Pagination page={page} total={total} limit={PAGE_SIZE} onPageChange={setPage} />
      </div>
      {showModal && (
        <Modal title={editing ? 'Editar Função' : 'Nova Função'} onClose={() => setShowModal(false)}>
          {error && <div className="p-3 rounded-md text-sm mb-4 bg-status-rejected/10 text-status-rejected border border-status-rejected/20">{error}</div>}
          <div className="mb-4"><label className="block text-sm font-medium text-ink-secondary mb-1">Nome</label>
            <input className="form-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></div>
          <div className="mb-4"><label className="block text-sm font-medium text-ink-secondary mb-1">Descrição</label>
            <textarea className="form-textarea" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} /></div>
          <div className="mb-4"><label className="block text-sm font-medium text-ink-secondary mb-1">Ordem de Exibicao</label>
            <input className="form-input" type="number" value={form.display_order} onChange={(e) => setForm({ ...form, display_order: parseInt(e.target.value) || 0 })} /></div>
          <div className="flex gap-3 justify-end mt-5">
            <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancelar</button>
            <button className="btn btn-primary" onClick={handleSave}>Salvar</button>
          </div>
        </Modal>
      )}
    </div>
  );
}
